import { Container } from '@tryhackme/thm-ui-components';
import { SEO } from 'src/common/components';
import { LoginForm } from 'src/features/login/components/login-form';
import { StyledLoginPage } from './login-page.styles';
export const LoginPage = () => <section data-sentry-component="LoginPage" data-sentry-source-file="login-page.tsx">
    <SEO title="Login" description="TryHackMe is a free online platform for learning cyber security, using hands-on exercises and labs, all through your browser!" alternateUrls={[{
    hreflang: 'en-gb',
    path: '/en-gb/login'
  }, {
    hreflang: 'fr',
    path: '/fr/login'
  }, {
    hreflang: 'x-default',
    path: '/login'
  }]} data-sentry-element="SEO" data-sentry-source-file="login-page.tsx" />
    <Container data-sentry-element="Container" data-sentry-source-file="login-page.tsx">
      <StyledLoginPage data-sentry-element="StyledLoginPage" data-sentry-source-file="login-page.tsx">
        <LoginForm data-sentry-element="LoginForm" data-sentry-source-file="login-page.tsx" />
      </StyledLoginPage>
    </Container>
  </section>;